import React from "react";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import EditIntegrationForm from "@/components/integrations/catalog/EditIntegrationForm";
import {
  IntegrationDto,
  IntegrationTagDto,
  IntegrationTagMappingDto,
} from "@/api/integrations";

interface Props {
  isOpen: boolean;
  integration: IntegrationDto | null;
  tagMappings: IntegrationTagMappingDto[];
  tags: IntegrationTagDto[];
  onDismiss: () => void;
  onSave: () => void;
}

const EditIntegrationPanel = (props: Props) => {
  if (!props.integration) return null;

  return (
    <RigthPanel
      header="Edit Integration"
      isOpen={props.isOpen}
      type={RigthPanelType.small}
      dismissPanel={props.onDismiss}
      childComponent={EditIntegrationForm}
      childProps={{
        integration: props.integration,
        tagMappings: props.tagMappings,
        tags: props.tags,
        onSave: props.onSave,
        onClose: props.onDismiss,
      }}
    />
  );
};

export default EditIntegrationPanel;
